import type { FaireProductEntity } from "../../entity_types/product";

export const p_hdsjwk36u7: FaireProductEntity = {
  token: "p_hdsjwk36u7",
  type: "product",
  name: "Aspen Cable Knit Beanie – Cozy & Stylish for Cold Weather",
  brandToken: "b_32rsz10vd0",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/e7125a6f4abb19cb6b0d8b9682d2f53005d5e28d76080aff8ad5d18ed38d7fe3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/433f673624a7dfa28bbea47d500bf224dfdc1765360cb78c5c0ba8c4c0f5227b.jpeg",
    "https://cdn.faire.com/fastly/928f8d67ea6a877c4df21e1664ceb433cbe381de9fcf68f827a30438beb5a3db.jpeg",
    "https://cdn.faire.com/fastly/b46f08ef5d8c5374b8b6475fc22ed4d27995b5f607450aac716db4df34c8d6ef.jpeg",
    "https://cdn.faire.com/fastly/2e4a94522d3a7a88fa9cdc5635489499449e9f0a9bdb998c63aa2ccca013514d.jpeg",
    "https://cdn.faire.com/fastly/b5f7de2e932095a2980e2a0baba7ed9a7bb7090a9e07cbf8adf553ebf6af644c.jpeg",
    "https://cdn.faire.com/fastly/6cd956f793aa75e2f7926b2d593deca12d2982b206331ccb9c7c80fabcf239d8.jpeg",
    "https://cdn.faire.com/fastly/05d0b86f8be90a8de790d304470f3cbd214dcc02a5e72267e3c0a60a337c3c5d.jpeg",
  ],
  priceDollars: 8.5,
  description:
    "🧢 Stay warm in style with the Aspen Cable Knit Beanie! Made from super soft, high-quality materials, this classic cable knit design provides the perfect balance of warmth and fashion. Whether you're hitting the slopes, exploring a winter wonderland, or just running errands, this versatile beanie adds a cozy finishing touch to any outfit. Available in a variety of fun colors, it’s the ultimate cold-weather essential for fall and winter styling.\n\nWhy You’ll Love It:\n❄️ Super Soft & Warm – Made for all-day comfort in chilly weather\n🧶 Classic Cable Knit Design – Timeless & fashionable for any look\n🖤 Versatile & Unisex – Perfect for casual, sporty, or dressed-up styles\n🌈 Available in Multiple Colors – Find your perfect match\n🎁 Great Gift Idea – A must-have for winter lovers & cozy accessory fans\n\n📏 Material: Ultra-soft knit fabric for warmth & durability\n\n🧣✨ Upgrade your winter wardrobe—shop the Aspen Cable Knit Beanie now! ✨❄️",
  tags: [],
  msrpDollars: 17,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:48.186Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
